// O `theme.panelCustomCSS` do chat, preparado para entrar na transcricao.
//
// PORQUE E QUE ISTO EXISTE
// O cartao de produto da transcricao usa as classes do widget, de proposito
// (ver ProductCardStrip.css). O CSS que o gestor do tenant escreve nas
// definicoes do widget e escrito contra essas mesmas classes e, na pratica, e
// quase todo sobre cartoes de produto: cores das etiquetas, a cor das linhas
// de entrega e disponibilidade, e o formato da moldura da foto. Sem isto o
// operador ve um cartao que nao e o que o cliente viu.
//
// COMO E QUE O CSS DO TENANT FICA DELIMITADO
// O texto do tenant e embrulhado em `@scope (<raiz>) { ... }` e entregue ao
// PARSER DE CSS DO BROWSER, numa CSSStyleSheet construivel. Do que sai de la so
// sobrevivem as regras que sao mesmo `CSSScopeRule` com a NOSSA raiz; essas
// voltam a texto e sao essas, e so essas, que vao para o <style>.
//
// O embrulho sozinho nao chegava, e e essa a razao de haver aqui um parser. Um
// bloco de CSS acaba no primeiro `}` sem par, portanto um texto do tenant com a
// forma `.card{...}` `}` `body{...}` `@media all{` fecha o `@scope` a meio e
// tudo o que vem depois passa a ser de topo. Medido: essas quatro linhas davam
// as regras `[CSSScopeRule, CSSStyleRule, CSSMediaRule]` e punham o `body` do
// backoffice magenta e em `position: fixed`, ou seja, o gestor de um tenant
// pintava por cima da sessao autenticada de um operador. Depois de passar pelo
// parser, a segunda e a terceira regras ficam pelo caminho aqui.
//
// A comparacao com a nossa raiz (`rule.start`) e o que trata do outro lado da
// mesma fuga: depois de fechar o nosso bloco a meio, o tenant pode abrir um
// `@scope (body)` dele, que tambem seria uma `CSSScopeRule`. Uma regra de scope
// que nao seja a nossa nao passa.
//
// O QUE ISTO GARANTE, E O QUE NAO GARANTE
// Garante que o que fica no <style> e uma unica regra `@scope` com a raiz da
// transcricao, escrita pelo parser do browser e nao por nos: os seletores do
// tenant so encontram elementos dentro da transcricao, o `@import` cai (dentro
// de `@scope` e invalido) e o `:root` dele foi reescrito para `:scope` para as
// custom properties aterrarem na raiz da transcricao em vez de caiem no chao.
//
// Nao garante nada sobre o QUE e feito aos elementos que sao mesmo apanhados.
// Sobre um elemento que esteja de facto dentro da transcricao:
//  - `position: fixed` escapa visualmente a qualquer scope. O bloco contentor
//    passa a ser a viewport, portanto um cartao pode ser pintado por cima do
//    cabecalho, da barra lateral e do resto do backoffice. O mesmo vale para
//    `z-index` alto com `position: absolute` e para transformacoes grandes.
//  - `url(...)` continua a fazer pedido de rede, em qualquer propriedade
//    (background-image, cursor, list-style-image, @font-face). Isso da a quem
//    escreveu o CSS um sinal de que um operador abriu aquela transcricao, com
//    o IP e o user-agent dele. Nao ha aqui exfiltracao do CONTEUDO da
//    conversa, mas o pedido e real.
//  - animacoes e `content` podem incomodar a leitura.
// CSS nao executa script nem le dados, portanto nada disto e execucao remota.
//
// NAO se tenta limpar o CSS a regex. Um filtro de seletores ou de propriedades
// escrito a mao da confianca falsa: o CSS tem escapes, comentarios e formas
// equivalentes de escrever a mesma coisa que qualquer regex falha, e o
// resultado seria acreditar que o perigoso foi removido quando nao foi. Quem
// decide aqui o que e uma fuga e o parser do browser, que e o mesmo que depois
// vai aplicar o resultado.
//
// O nivel de confianca, ainda assim, nao e novo: este CSS e escrito pelo
// gestor do proprio tenant no backoffice e ja corre, sem qualquer scope, no
// widget publico do cliente. O que muda e passar a correr tambem na sessao
// autenticada de um operador, e e por isso que aqui vai delimitado.
//
// O `launcherCustomCSS` NAO entra: e sobre o botao flutuante, que aqui nao
// existe, portanto so traria superficie sem trazer fidelidade nenhuma.

// `:root` do tenant e o painel do widget; o nosso e o contentor da
// transcricao. Reescrever para `:scope` e o que o autor queria dizer.
//
// Isto e uma REESCRITA, nao um filtro de seguranca: o objetivo e as declaracoes
// aterrarem no sitio certo, e o pior que a regex pode fazer e trocar um `:root`
// que estivesse dentro de uma string ou de um comentario, o que nao tem
// consequencia. A guarda no fim evita apanhar um `:root-qualquer-coisa`.
//
// O `html` opcional a frente nao e zelo: os tenants escrevem `html:root`, que e
// a forma que o Tailwind e os temas de loja deixam nos ficheiros deles, e a
// nossa raiz e uma DIV. Deixar o tipo de elemento no seletor da `html:scope`,
// que exige que a raiz do scope seja um <html> e portanto nunca encontra nada.
// Medido: o WebKit 18 e o Firefox nao aplicavam NADA do bloco de raiz do MODZ
// nem do da Delta por causa disto, nem as fontes, nem as cores das etiquetas;
// so o Chromium salvava o caso, porque deita fora o tipo de elemento de
// qualquer `<tipo>:scope` (la dentro ate um `span:scope` encontra uma div).
const ROOT_SELECTOR = /(?:\bhtml)?:root(?![\w-])/g;

// `window.CSSScopeRule` em vez do global cru: o global nao existe em todos os
// browsers e nomea-lo diretamente so daria um ReferenceError mais dificil de
// ler do que este `typeof`.
const isOwnScopeRule = (rule, scopeSelector) => {
  const ScopeRule = window.CSSScopeRule;
  return (
    typeof ScopeRule === "function" &&
    rule instanceof ScopeRule &&
    // A raiz que o parser devolve, comparada com a que nos pedimos. Uma regra
    // `@scope` que o tenant tenha aberto por si nao e esta.
    rule.start === scopeSelector
  );
};

/**
 * As regras `@scope` com a NOSSA raiz, ja passadas pelo parser do browser.
 * Base das duas leituras que este ficheiro exporta: o CSS que vai para o
 * <style> e o valor de uma custom property que o tenant declarou.
 *
 * Devolve vazio, e nao levanta, em tudo o que corra mal. Sem stylesheet
 * construivel nao ha parser a quem perguntar o que este texto e, e injetar por
 * injetar seria acreditar na forma dele. Sem tema o cartao fica com os defaults
 * do widget, que vivem no index.css precisamente para sobreviverem a este caso:
 * perde-se a cor do tenant, nao se perde a transcricao. O mesmo vale para um
 * browser sem `@scope`, onde o parser deita fora a at-rule inteira e nao sobra
 * regra nenhuma para guardar.
 *
 * @param {string|undefined} css o `theme.panelCustomCSS` do chat
 * @param {string} scopeSelector seletor da raiz, ex. ".transcript"
 * @returns {CSSScopeRule[]}
 */
function parseOwnScopeRules(css, scopeSelector) {
  if (typeof css !== "string") return [];
  const trimmed = css.trim();
  if (!trimmed) return [];

  const SheetCtor = window.CSSStyleSheet;
  if (typeof SheetCtor !== "function") return [];
  let sheet;
  try {
    sheet = new SheetCtor();
  } catch {
    return [];
  }
  if (typeof sheet.replaceSync !== "function") return [];

  const wrapped = `@scope (${scopeSelector}) {\n${trimmed.replace(
    ROOT_SELECTOR,
    ":scope"
  )}\n}`;
  try {
    sheet.replaceSync(wrapped);
  } catch {
    // O parser nao levanta erro por CSS invalido, deita fora o que nao percebe.
    // Isto e a rede para o resto (uma folha adotada por um documento, por
    // exemplo), e a direcao segura e nao injetar nada.
    return [];
  }

  return Array.from(sheet.cssRules).filter((rule) =>
    isOwnScopeRule(rule, scopeSelector)
  );
}

/**
 * @param {string|undefined} css o `theme.panelCustomCSS` do chat
 * @param {string} scopeSelector seletor da raiz, ex. ".transcript"
 * @returns {string|null} o CSS pronto a meter num <style>, ou null se nao ha
 *   nada para injetar
 */
export function scopePanelCustomCss(css, scopeSelector) {
  const kept = parseOwnScopeRules(css, scopeSelector).map((rule) => rule.cssText);
  return kept.length ? kept.join("\n") : null;
}

/**
 * O valor que o tenant declarou para uma custom property na raiz do painel.
 *
 * Existe porque ha decisoes que o backoffice tem de tomar em JAVASCRIPT e nao
 * podem sair de uma cadeia de `var()`. O balao do agente e a que motivou isto:
 * ou o par fundo/texto vem todo do widget, ou vem todo da primaria do chat, e
 * misturar as duas metades escreve texto que nao se le (um tenant que pinte o
 * balao mas nao o texto acabaria com o branco calculado para a primaria por
 * cima do creme que escolheu para o balao). Em CSS nao ha como dizer "estes
 * dois valores andam juntos"; aqui ha.
 *
 * So se olha para declaracoes na raiz, que e no que o `:root` (ou o
 * `html:root`) do painel fica depois da reescrita. Uma declaracao dentro de um
 * `@media` do tenant fica de fora: nao ha aqui como saber se a condicao dele
 * vale no backoffice. Quem nao encontra nada mantem o aspeto de hoje, que e a
 * direcao segura.
 *
 * O valor devolvido e o texto tal e qual o tenant o escreveu, que pode ser
 * qualquer notacao de cor que o CSS aceite. Quem so souber ler uma delas que
 * verifique antes de a usar; hoje o `ConversationDetail` so mede hex, e uma
 * cor em `rgb()` ou `hsl()` cai no aspeto de hoje em vez de pintar o balao.
 *
 * @param {string|undefined} css o `theme.panelCustomCSS` do chat
 * @param {string} scopeSelector seletor da raiz, ex. ".transcript"
 * @param {string} property nome da custom property, ex. "--kodly-ai-agent-x"
 * @returns {string|null} o valor declarado, ou null se o tenant nao o declarou
 */
// Uma lista de seletores tambem conta, desde que uma das partes seja mesmo a
// raiz: o `.claude/rules/widget-settings.md` manda os tenants declararem tokens
// em `:root`, e quem junta ali o painel (`:root, .kodly-ai-agent-panel`) esta a
// declarar na raiz na mesma. Partir por virgulas erra numa virgula dentro de um
// `:is(...)`, e nesse caso nao se encontra a raiz e fica o aspeto de hoje.
const declaresOnScopeRoot = (selectorText) =>
  selectorText.split(",").some((part) => part.trim() === ":scope");

export function readScopedCustomProperty(css, scopeSelector, property) {
  let found = null;
  for (const scope of parseOwnScopeRules(css, scopeSelector)) {
    for (const rule of scope.cssRules) {
      if (!(rule instanceof window.CSSStyleRule)) continue;
      if (!declaresOnScopeRoot(rule.selectorText)) continue;
      const value = rule.style.getPropertyValue(property).trim();
      // A ultima ganha, como na cascata: os tenants abrem mais do que um bloco
      // de raiz no mesmo ficheiro (o MODZ tem dois, um para as fontes e as
      // cores base e outro para as etiquetas do cartao).
      if (value) found = value;
    }
  }
  return found;
}
